import { render, staticRenderFns } from "./ChartPieStat.vue?vue&type=template&id=e06fbdcc&scoped=true&"
import script from "./ChartPieStat.vue?vue&type=script&lang=js&"
export * from "./ChartPieStat.vue?vue&type=script&lang=js&"
import style0 from "./ChartPieStat.vue?vue&type=style&index=0&id=e06fbdcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06fbdcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06fbdcc')) {
      api.createRecord('e06fbdcc', component.options)
    } else {
      api.reload('e06fbdcc', component.options)
    }
    module.hot.accept("./ChartPieStat.vue?vue&type=template&id=e06fbdcc&scoped=true&", function () {
      api.rerender('e06fbdcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accountTB/ChartPieStat.vue"
export default component.exports